import { Pessoa } from "@/types/administracao/pessoa";

export class UnidadeGestoraResumida {
  Codigo?: string;
  IdPCM?: number;
  Sigla?: string;
  Nome: string;
  idCRP?: string;
  //Exibe gestor da UG
  gestorUG?: Pessoa;

  constructor(obj?: any) {
    // objetos em maiúsculo são do backend node
    // objetos em minúsculo são do backend dotnet
    // objetos em outro padrão são do além
    if (obj) {
      //console.log(obj)
      if (obj.CODIGO) this.Codigo = obj.CODIGO;
      if (obj.cod_ug_sagres) this.Codigo = obj.cod_ug_sagres;
      if (obj.ID_UNIDADAE_GESTORA) this.IdPCM = obj.ID_UNIDADAE_GESTORA;
      if (obj.NM_SIGLA) this.Sigla = obj.NM_SIGLA;
      if (obj.NM_NOME) this.Nome = obj.NM_NOME;
      if (obj.NOME) this.Nome = obj.NOME;
      if (obj.ID) this.idCRP = obj.ID;
      if (obj.ID_CRP_UG) this.idCRP = obj.ID_CRP_UG;

      //Construtor para obter informações do gestor da ug
      if (
        obj.CRP_PESSOA_FISICA_CRP_UNIDADEGESTORA_ID_GESTORToCRP_PESSOA_FISICA
      ) {
        this.gestorUG = new Pessoa(
          obj.CRP_PESSOA_FISICA_CRP_UNIDADEGESTORA_ID_GESTORToCRP_PESSOA_FISICA.CRP_PESSOA.ID,
          obj.CRP_PESSOA_FISICA_CRP_UNIDADEGESTORA_ID_GESTORToCRP_PESSOA_FISICA.CRP_PESSOA.NM_NOME_PESSOA
        );
      }

      //construtor do dotnet
      if (obj.Id) this.IdPCM = obj.Id;
      if (obj.Nome) this.Nome = obj.Nome;
      if (obj.Codigo) this.Codigo = obj.Codigo;

      if (obj.NmNome) this.Nome = obj.NmNome;
    }
  }
}
